import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

function Catalog({ kind, columns }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/admin/masters/${kind}`).then(({ data }) => setItems(data)).catch(() => {}); }, [kind]);
  return (
    <div className="surface-card p-4 overflow-x-auto">
      <Table>
        <TableHeader><TableRow>{columns.map((c) => <TableHead key={c}>{c}</TableHead>)}</TableRow></TableHeader>
        <TableBody>
          {items.map((i) => (
            <TableRow key={i.id}>
              <TableCell className="font-semibold">{i.name}</TableCell>
              <TableCell className="text-sm">{i.code || "—"}</TableCell>
              <TableCell className="text-xs">{Object.entries(i.meta || {}).map(([k, v]) => `${k}: ${v}`).join(" · ") || i.description || "—"}</TableCell>
              <TableCell>{i.active !== false ? <Badge>On</Badge> : <Badge variant="outline">Off</Badge>}</TableCell>
            </TableRow>
          ))}
          {items.length === 0 && <TableRow><TableCell colSpan={columns.length} className="text-center text-muted-foreground py-10">Catalog will appear once the platform Super Admin uploads masters.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </div>
  );
}

export default function Products() {
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="sales-products">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">Product catalogue</h1>
        <p className="text-muted-foreground">Read-only catalogue used in quotations & orders — categories, sizes, finishes, materials, colors, patterns and HSN/Tax codes.</p>
      </div>
      <Tabs defaultValue="categories">
        <TabsList>
          {["categories","sizes","finishes","materials","colors","patterns","units","tax_codes","hsn_codes"].map((k) =>
            <TabsTrigger key={k} value={k} data-testid={`prod-tab-${k}`}>{k.replace("_"," ")}</TabsTrigger>)}
        </TabsList>
        {["categories","sizes","finishes","materials","colors","patterns","units","tax_codes","hsn_codes"].map((k) => (
          <TabsContent key={k} value={k}>
            <Catalog kind={k} columns={["Name","Code","Details","Active"]} />
          </TabsContent>
        ))}
      </Tabs>
      <Card><CardContent className="p-4 text-xs text-muted-foreground">For live stock availability, switch to the <strong>Inventory</strong> menu.</CardContent></Card>
    </div>
  );
}
